function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Unknown_svg__clip0_1_112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.674 18.674a1.875 1.875 0 002.652 2.652l-2.652-2.652zm12.652-7.348a1.875 1.875 0 00-2.652-2.652l2.652 2.652zm-10 10l10-10-2.652-2.652-10 10 2.652 2.652z",
  fill: "#828282"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.326 18.674a1.875 1.875 0 01-2.652 2.652l2.652-2.652zM8.674 11.326a1.875 1.875 0 112.652-2.652l-2.652 2.652zm10 10l-10-10 2.652-2.652 10 10-2.652 2.652z",
  fill: "#828282"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Unknown_svg__clip0_1_112"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "2a2fa21d0590c2020a2ef1db271de8a6.svg";
export { SvgUnknown as ReactComponent };